import React from 'react';
import { useEffect } from "react"
// import { Sidebar } from "./Sidebar";
import Dashboard from '../Dashboard';
import { getUser } from '../../service';
import { history } from '../../router/route';
import { login } from '../../middleware';
import { Cookies } from 'react-cookie'
import '../../styles/header.css'
import Header from './Header'
import '../../styles/dashboard.css';


const Layout = (props) => {
  const cookies = new Cookies()
  function contentRender() {
    return <Dashboard />
  }


  useEffect(() => {
    getUser().then(res=>{
      
      if(res.code === 200){
        cookies.set('profile', JSON.stringify(res.result))
      }else if(res.response !== undefined){
        if (res.response.status === 401) {
          cookies.remove("user")
          login()
        }
      }
    }).catch(err=>{
      history.push("/login")
      history.go(0)
    })
  })
  return (
    <>
      {/* 
      <div role="main" className="main-content" id="panel"  >
        <Container fluid>
          {contentRender()}
        </Container>
      </div> */}
      <Header />

      <div className="container-fluid">
        <div className="row">

          {/* <Sidebar /> */}
          <main role="main" className="col-md-12 ml-sm-auto col-lg-12 px-md-4 mb-5">
            {contentRender()}
          </main>
        </div>
      </div>

      {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        
      </div > */}
    </>
  )
}

export default Layout